import React, { useEffect, useState } from 'react'

import { RadioButton } from 'primereact/radiobutton';


import { getPreguntasEncuesta, guardarRespuestas } from '../../../../../API/Externo/Encuestas/EnquestasRequests'

import './EncuestaClimaLaboralScreen.scss'
import { Button } from 'primereact/button';
import Loader from '../../../../../Base/Components/Loader/Loader';
import { Toast } from 'primereact/toast';
import { toastShow } from '../../../../../Base/Services/ToastService';
import { InputTextarea } from 'primereact/inputtextarea';
import { useParams } from 'react-router-dom';
import { getSecciones, getSeccionesDistincToken } from '../../../../../API/RRHH/Organigrama/Secciones';
import { getPosiciones, posicionesDistinc } from '../../../../../API/RRHH/Organigrama/Posiciones';
import Card from '../../../../../Base/Components/Card/Card';
import AutoCompleteDropdown from '../../../../../Base/Components/Form/AutoCompleteDropdown';
import { useForm } from '../../../../../Base/Hooks/useForm';
import { getPersonalSinToken } from '../../../../../API/RRHH/Personal/PersonalRequests';

const EncuestaClimaLaboralScreen = ({ QR = false }) => {

    const toast = React.useRef(null);

    const [errorsGroup, setErrorsGroup] = useState([]);

    const [errorPregunta, setErrorPregunta] = useState([]);

    const [comentario, setComentario] = useState('');
    const [enlaceValido, setEnlaceValido] = useState(true);

    const [posiciones, setPosiciones] = useState([]);
    const [secciones, setSecciones] = useState([]);
    const [personal, setPersonal] = useState([]);


    const { values, setValues, handleChange, handleInputChange, resetForm } = useForm({});

    const { IdEncuesta } = useParams();

    const { CodigoLink } = useParams();

    const opciones = [
        {
            id: 1,
            name: 'Totalmente en desacuerdo',
            value: 1
        },
        {
            id: 2,
            name: 'En desacuerdo',
            value: 2
        },
        // {
        //     id: 3,
        //     name: 'Ni de acuerdo ni en desacuerdo',
        //     value: 3
        // },
        {
            id: 4,
            name: 'De acuerdo',
            value: 4
        },
        {
            id: 5,
            name: 'Totalmente de acuerdo',
            value: 5
        }
    ]


    const [loading, setLoading] = useState(false);
    const [preguntasGroup, setPreguntasGroup] = useState([]);
    const [respuestas, setRespuestas] = useState([]);

    const getInfo = async () => {
        setLoading(true);
        const result = await getPreguntasEncuesta(IdEncuesta, { QR }, CodigoLink ? CodigoLink : null);
        const s = await getSeccionesDistincToken();
        setSecciones(s);

        if (result?.length === 0) {
            toastShow(toast, 'error', 'Error', 'No se encontraron preguntas',);
            setPreguntasGroup([]);
            setEnlaceValido(false);
        } else {
            setPreguntasGroup(result);
        }
        setLoading(false);
    
}

    const verificarLleno = () => {
        let lleno = true;
        let errorG = [];
        let errorP = [];
        preguntasGroup.forEach((item, index) => {
            for (let i = 0; i < item.Preguntas.length; i++) {
                const pregunta = item.Preguntas[i];
                if (!respuestas.find(x => x.IdPregunta === pregunta.IdPregunta)) {
                    lleno = false;
                    // toastShow(toast, 'error', 'Fata completar en ' +  item.Titulo , + (i + 1) + ' - ' +  pregunta.Pregunta,);
                    errorG.push(item.IdPreguntaGrupo);
                    errorP.push(pregunta.IdPregunta);
                    // break;
                }
            }
        })
        if (!lleno) {
            toastShow(toast, 'error', 'Debe completar todas las preguntas', 'Favor de completar todas las preguntas',);
        }
        if (values?.Seccion === null || values?.Seccion === undefined) {
            lleno = false;
            errorG.push("Seccion");
            toastShow(toast, 'error', 'Debe de seleccionar la sección', 'Favor de seleccionar la sección',);
        }
        setErrorsGroup(errorG);
        setErrorPregunta(errorP);
        if (Object.keys(errorG).length === 0 || Object.keys(errorP).length === 0) {
            setErrorPregunta([])
            setErrorsGroup([])
            return true;
        } else {
            return false;
        }
        // return lleno;
    }

    const guardar = async () => {
        if (verificarLleno()) {
            const data = {
                IdEncuesta: IdEncuesta,
                Respuestas: [...respuestas,
                {
                    IdPregunta: 143,
                    ValueInt: null,
                    ValueString: comentario,
                    value: null,
                }],
                IdSeccion: values.Seccion.IdSeccion,
            }
           
            const result = await guardarRespuestas(data);
            if (result) {
                if (result[0].ESTADO === 1) {
                    toast.current.show({ severity: 'success', summary: 'Guardado', detail: 'Se guardo correctamente', life: 3000 });
                    setRespuestas([]);
                    setComentario('');
                    // navegar a /web/encuesta/End
                    window.location.href = '/web/encuesta/End';
                } else {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: 'No se pudo guardar', life: 3000 });
                }
            }
        }
    }

    const changeRespuesta = (e, item) => {
        const r = respuestas.filter(x => x.IdPregunta !== item.IdPregunta);
        const rest = [...r, {
            IdPregunta: item.IdPregunta,
            ValueInt: e.value,
            ValueString: null,
            value: e.value,
        }]
        setRespuestas(rest)
    }


    const setPreguntaContent = (item, index) => {
        return <div className='preguntaContent'>
            <Loader loading={loading} />
            <div>
                <span className={'text-bold pregunta ' + (errorPregunta.includes(item.IdPregunta) ? ' errorP' : '')}>{index + 1} - {item.Pregunta} </span>
            </div>
            <div className='preguntaContentOptions'>
                {opciones.map((itemResp, index) => {
                    return <div className='preguntaContentOption'>
                        <div key={itemResp.id} className="preguntaContentOption2 py-3 px-2 col-12" onClick={e => changeRespuesta(itemResp, item)}>
                            <RadioButton className='preguntaContentOptionInput' inputId={item.IdPregunta + '-' + itemResp.value} name={item.IdPregunta} value={itemResp.value}
                                checked={respuestas.find(x => x.IdPregunta === item.IdPregunta && x.value === itemResp.value)}
                            />
                            <label className={respuestas.find(x => x.IdPregunta === item.IdPregunta && x.value === itemResp.value) ? 'label text-bold' : 'label'} htmlFor={item.IdPregunta + '-' + itemResp.value}> {itemResp.name}</label>
                        </div>
                    </div>
                })
                }
            </div>
        </div>
    }

    const setTemplatePreguntasGroup = (item, index) => {
        return <div className={'preguntaGroup card ' + (errorsGroup.includes(item.IdPreguntaGrupo) ? ' erroGroup ' : ' ')} >
            <div className='preguntaGroupTitle'>
                <h2 className='text-bold'>{index + 1} - {item.TituloPreguntasGroup}</h2>
            </div>
            <div>
                {item.Preguntas.map(setPreguntaContent)}
            </div>
        </div>
    }

    useEffect(() => {
        getInfo();
    }, [])


    return (
        <div style={{ height: '100vh', overflow: 'scroll' }}>
            <Loader loading={loading} />
            <Toast ref={toast} />
            <div className='EncClimaLaboral'>
                <div className="titulo">
                    <img src={process.env.REACT_APP_Logo_Primario_H} alt="" className="login__empresa-logo" />
                    <h1>Encuesta de Clima Laboral</h1>
                </div>
                <div>
                    {!enlaceValido ?
                        <div style={{ marginTop: 200 }}><h2>Enlace no valido</h2></div>
                        :
                        <div>
                            <div>
                                <div className="encabezado">
                                    <div className='instrucciones'>
                                        <p className='subtitulo'>Este cuestionario tiene como único fin analizar la forma en que el personal de la empresa percibe el ambiente de trabajo en el que se desempeña, de esta manera con la colaboración de todos podremos mejorar nuestro entorno laboral.</p>
                                        <h5>Instrucciones:</h5>
                                        <p className='subtitulo'>
                                            La serie de preguntas que se realizan a continuación presentan una escala del 1 al 5 de acuerdo al grado de aprobación o desaprobación de cada afirmación. Marque la respuesta que considere correcta.
                                        </p>
                                        <ul >
                                            {opciones.map((item, index) => {
                                                return <li key={index}><span className='text-bold'>{item.id}</span> - {item.name}</li>
                                            })
                                            }
                                        </ul>
                                    </div>
                                </div>

                                <div>
                                    <Card
                                        contenido={<div className='selectSeccion d-flex justify-content-center gap'>
                                            <div className='tituloSeccion'>
                                                <h3 className=''>Seleccione el área a la que pertenece:</h3>
                                            </div>
                                            <div className="autocomplete">
                                                <AutoCompleteDropdown
                                                    value={values.Seccion}
                                                    handleInputChange={handleInputChange}
                                                    name={'Seccion'}
                                                    field={'Seccion'}
                                                    items={secciones}
                                                />
                                            </div>
                                            {/* <div className="col-6">
                                                <AutoCompleteDropdown
                                                    value={values.Personal}
                                                    handleInputChange={handleInputChange}
                                                    name={'Personal'}
                                                    field={'CodigoNombre'}
                                                    items={personal}
                                                    label='Jefe inmediato'
                                                />
                                            </div> */}
                                        </div>}

                                    />
                                </div>



                                <div className='EncClimaLaboral'>
                                    <div className="Preguntas">
                                        <div className="PreguntasGroup">
                                            {
                                                preguntasGroup.map(setTemplatePreguntasGroup)
                                            }
                                        </div>

                                        <div className={'preguntaGroup card comentario' + (errorsGroup.includes(-1) ? ' erroGroup ' : ' ')} >
                                            <span className='text-bold'>Si tiene algún comentario por favor, dé a conocer su opinión. </span>
                                            <InputTextarea
                                                value={comentario}
                                                onChange={(e) => setComentario(e.target.value)}
                                                rows={5} cols={30}
                                                autoResize
                                                placeholder="Comentarios"
                                            />
                                        </div>
                                    </div>
                                    <div className="botones gap mb-5">
                                        {/* <Button label="Cancelar" raised rounded className="" severity='info' icon={'pi pi-times'} /> */}
                                        <Button style={{ fontSize: '2rem' }} label="Guardar" raised rounded icon={'pi pi-save'} onClick={guardar} />

                                    </div>

                                </div>
                            </div>


                        </div>}


                </div>


            </div>


        </div>
    )
}

export default EncuestaClimaLaboralScreen